import { ConsentProviderPort } from '../../ports'
import {
  BroadcastPort,
  CmpImpl,
  CONSENT_CHANGED_BROADCAST_EVENT,
} from '@otto-ec/eprivacy-shared'

export async function informClientOnConsentChanged(
  consentProvider: ConsentProviderPort,
  cmp: CmpImpl,
  broadcastPort?: BroadcastPort
): Promise<void> {
  try {
    await cmp.archiveReceipt(consentProvider.getConsentId(), 'OneTrust-CB-Web')
  } catch (e) {
    console.log(e)
  } finally {
    broadcastPort?.send(CONSENT_CHANGED_BROADCAST_EVENT)
    await cmp.emitConsentChangeEvent()
  }
}
